import { render, staticRenderFns } from "./fichaCliente.vue?vue&type=template&id=62823a7c"
import script from "./fichaCliente.vue?vue&type=script&lang=js"
export * from "./fichaCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports